<div class="layout-footer">
  <div class="logo-text">
    <div style="cursor: pointer" (click)="radportalLink()">
      <img
        src="assets/layout/images/radportal-logo-mini.png"
        alt="mirage-layout"
      />
    </div>

    <div class="text">
      <div style="cursor: pointer" (click)="radportalLink()">
        <h1>RadPortal</h1>
      </div>

      <span>Version: 1.26.0</span>
    </div>
  </div>
</div>
